import React from 'react';
import { connect } from 'react-redux';
import LOLOMO from './lolomo';
import Footer from './footer';
import NavigationBar from './navigation-bar';
import { cloneDeep } from 'lodash';

import { removeDropdown, setSelectedAsset, setSelectedAssetRow } from '../../redux/actions/SVOD';
import { DISPLAY_TYPES, CONTENT_TYPES, ROW_LABELS } from "./constants";
import appletvPlusBanner from '../../assets/included_appletv+banner.jpg';
import { EnvType, FORCED_ENTRY, MANUAL_NAVIGATION, IWATVP_PLUS_NAVIGATION, SVOD_ASSET_NAVIGATION } from './constants';
import { isAppleTVGuidedTargetPrompt, returnTargetAssetInfo, returnTimeInSVOD } from '../../functions/utils';

class AppleTVPlusPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	componentDidMount() {
		const {
			autoNavigateToIncludedAppleTVPage,
			handleIncludedAppleTVPlusExperienceInterval,
			handleSVODPanelResponses,
			eventHandler,
			fetchedGroup
		} = this.props;

		eventHandler({ data: { event_type: "page_enter", page_location: "included_appletv_plus", time: Date.now() } });

		if (autoNavigateToIncludedAppleTVPage) {
			eventHandler({ data: { event_type: "end_auto_navigation" } });
			handleSVODPanelResponses(FORCED_ENTRY, IWATVP_PLUS_NAVIGATION, '', IWATVP_PLUS_NAVIGATION);
		}

		if (!autoNavigateToIncludedAppleTVPage && handleIncludedAppleTVPlusExperienceInterval) {
			// starts the time interval once the user enters the Included with Apple TV page
			// this.props.handleIncludedAppleTVPlusExperienceInterval(); // commented out temporarily
			handleSVODPanelResponses(MANUAL_NAVIGATION, IWATVP_PLUS_NAVIGATION, '', IWATVP_PLUS_NAVIGATION);
		}
	}

	componentWillUnmount() {
		this.props.eventHandler({ data: { event_type: "page_exit", page_location: "included_appletv_plus", time: Date.now() } });
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			autoNavigateToTargetAsset,
			beginAppleGuidedExperience,
			autoNavigateToIncludedAppleTVPage,
			autoNavigateToHome,
			environment,
			fetchedGroup,
			forceGuidedExperience,
			promptedForceTargetAsset,
			promptedTargetAsset,
			svodStartTime,
			totalModalTime,
			targetAssets,
			targetAssetIndex,
			video,
			videos,
			eventHandler
		} = this.props;

		const currentTargetAsset = targetAssets ? targetAssets[targetAssetIndex] : undefined;
		const isCurrentVideoTargetAsset = currentTargetAsset && video && video._id === (currentTargetAsset.id || currentTargetAsset._id);
		const { svod_env } = fetchedGroup;
		const isAppleTVGuidedExperience = svod_env && svod_env.guided_experience && svod_env.guided_experience.included_appletv_page;

		if (beginAppleGuidedExperience
			&& environment === EnvType.APPLETV
			&& !promptedTargetAsset
		) {
			if ((currentTargetAsset && !isCurrentVideoTargetAsset) || isAppleTVGuidedExperience) {
				eventHandler({
					data: {
						event_type: 'apple_prompt_to_target_asset',
						page_location: "included_appletv_plus",
						targetAsset: currentTargetAsset ? currentTargetAsset.name : '',
					}
				});
			}
		}

		if (forceGuidedExperience
			&& environment === EnvType.APPLETV
			&& !promptedForceTargetAsset
			&& (!isCurrentVideoTargetAsset || isAppleTVGuidedExperience)
		) {
			let targetAssetName = currentTargetAsset ? currentTargetAsset.name : "";
			eventHandler({
				data: {
					event_type: 'apple_force_to_target_asset',
					page_location: "included_appletv_plus",
					targetAsset: targetAssetName
				}
			});
		}

		if (autoNavigateToTargetAsset && !isCurrentVideoTargetAsset) {
			const { targetAsset, targetAssetRow } = returnTargetAssetInfo(targetAssetIndex, targetAssets, videos);

			this.props.setSelectedAsset(targetAsset);
			this.props.setSelectedAssetRow(targetAssetRow);

			const targetAssetId = targetAsset ? targetAsset.id || targetAsset._id : "";
			const submittedSVODKey = `${SVOD_ASSET_NAVIGATION}-${targetAssetId}`;
			const submittedAnswer = returnTimeInSVOD(svodStartTime, totalModalTime);
			this.props.handleSVODPanelResponses(submittedAnswer, submittedSVODKey, targetAssetId, SVOD_ASSET_NAVIGATION);

			const targetAssetNode = document.getElementById(targetAssetId);
			if (targetAssetNode) targetAssetNode.click();
		}

		if (autoNavigateToIncludedAppleTVPage || autoNavigateToHome) {
			const backArrowButton = document.getElementById('navigationBackArrow');
			if (backArrowButton) backArrowButton.click();
		}
	}

	returnValidVideos(appleTVVideos, row, svod_env) {
		const validVideosObj = {};
		if (appleTVVideos[row]) {
			for (let asset_id in appleTVVideos[row]) {
				const video = cloneDeep(appleTVVideos[row][asset_id]);

				if (video.original_theme) video.disabledAsset = true;
				if (!video.transactional) validVideosObj[asset_id] = video;
			}
		}

		return validVideosObj;
	}

	render() {
		const {
			environment,
			appleTVVideos,
			dropdown,
			fetchedGroup
		} = this.props;

		const rowLabels = Object.keys(appleTVVideos);
		const rowInformation = fetchedGroup.svod_env.appletv_plus_rows;
		const { svod_env } = fetchedGroup;

		let appleTVPlusRowLabels = rowLabels.filter(function (value) { return !value.includes(ROW_LABELS.BILLBOARD); });
		let isDynamicBillboard = false;

		let lolomos = appleTVPlusRowLabels.map((row, idx) => {
			let contentType = ""; // highlight, latest_releases, coming_soon
			let description;
			let currentRowInfoObject;

			if (rowInformation) {
				rowInformation.forEach((rowInfoObject) => {
					if (row.includes(rowInfoObject.id)) {
						if (rowInfoObject.row_type) {
							contentType = rowInfoObject.row_type;
						}
						if (rowInfoObject.display_type && rowInfoObject.display_type === DISPLAY_TYPES.HIGHLIGHT) {
							contentType = CONTENT_TYPES.HIGHLIGHT;
						}
						description = rowInfoObject.description;
						currentRowInfoObject = rowInfoObject;
					}
				});
			}

			const validAppleTVVideos = this.returnValidVideos(appleTVVideos, row, svod_env);

			return (
				<LOLOMO {...this.props}
					disableThumbnails={true}
					videos={validAppleTVVideos}
					rowIndex={idx}
					row_type={contentType}
					activeDropdown={dropdown}
					isCuratedRow={false}
					rowInfoObject={currentRowInfoObject}
					label={row}
					key={`lolomo`}
					description={description}
					pageLocation='included_with_apple_page'
				/>
			);
		});

		const style = isDynamicBillboard ? { top: '-236px', marginBottom: '-236px' } : {};
		const addedClass = isDynamicBillboard ? 'position-absolute' : '';

		return (
			<div className="showpage-index index position-relative" id="svod-page" >
				<div id="top"></div>
				<NavigationBar {...this.props} backRoute={this.props.backRoute} page="/study/included-with-apple-tv" />

				<div className='appletv-banner-wrapper position-relative'>
					<img className='width-100p' src={appletvPlusBanner} />
					<div className='position-absolute width-100p' style={{ top: '160px' }}>
						<p className='appletv-banner-description m-auto'>
							Unforgettable hits filled with iconic performances and legendary moments. As a limited-time subscriber bonus, watch these companion films to the newest Apple Originals.
						</p>
					</div>
				</div>

				<div className="position-relative" style={style}>
					{lolomos}
				</div>

				<Footer environment={environment} />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	video: state.SVOD.selectedAssets.asset,
	appleTVVideos: state.SVOD.appleTVVideos,
	videos: state.SVOD.videos,
	selectedAssetRow: state.SVOD.selectedAssets.assetRow,
	dropdown: state.SVOD.dropdown,
	environment: state.SVOD.environment,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
	targetAssets: state.targetProcess.fetchedGroup.svod_env.target_assets,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	removeDropdown: () => dispatch(removeDropdown()),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppleTVPlusPage);



// WEBPACK FOOTER //
// ./src/components/svod/AppleTVPlusPage.js